import {HYDRATE} from 'next-redux-wrapper';
import {TRADE_CONSTANTS} from '../actions/TradeActions';

const TRADE_INITIATE_STATE = {
    markets: null,
    marketsById: null,
    marketsBySymbol: null,
    marketsSoon: {},
    pairMarket: null,
    fiatMarket: null,
    openTrades: null,
    marketPrices: {},
    error: null
};

export default function Trade(state = TRADE_INITIATE_STATE, action) {
    switch (action.type) {
        case HYDRATE:
            return {...state, ...action.payload.Trade};

        case TRADE_CONSTANTS.GET_MARKETS:
            return {
                ...state,
                markets: action.payload.markets,
                marketsBySymbol: action.payload.marketsBySymbol,
                marketsById: action.payload.marketsById,
                marketsSoon: action.payload.marketsSoon,
                pairMarket: action.payload.pairMarket,
                fiatMarket: action.payload.fiatMarket,
                error: null,
            };

        case TRADE_CONSTANTS.MARKET_PRICES:
            return {
                ...state,
                marketPrices: {
                    ...state.marketPrices,
                    ...action.payload
                },
            };

        case TRADE_CONSTANTS.GET_OPEN_TRADES:
            return {
                ...state,
                openTrades: action.payload,
                error: null,
            };

        case TRADE_CONSTANTS.FAILURE:
            return {
                ...state,
                error: action.payload,
            };

        case TRADE_CONSTANTS.RESET:
            return {...TRADE_INITIATE_STATE};

        default:
            return state;
    }
}